const ITEMS_TO_LOAD = 20

export default ITEMS_TO_LOAD
